/* Conservative search alias: fix the common Quantic misspelling without altering SKUs or other queries. */
(() => {
  const fold = value => String(value || '').toLocaleLowerCase('tr-TR')
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/ı/g, 'i');
  const normalize = value => {
    const raw = String(value || '');
    if (raw.includes(':')) return raw;
    return raw.replace(/[\p{L}][\p{L}\p{N}-]*/gu, token =>
      fold(token) === 'kuantik' ? 'quantic' : token
    );
  };
  const search = new URL(location.href);
  if (search.pathname.endsWith('/search')) {
    const query = search.searchParams.get('q');
    if (query && normalize(query) !== query) {
      search.searchParams.set('q', normalize(query));
      location.replace(search.href);
      return;
    }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('role') !== 'search') return;
    const field = form.elements.namedItem('q');
    if (!field || !field.value) return;
    const fixed = normalize(field.value);
    if (fixed !== field.value) field.value = fixed;
  }, true);
})();
